import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationTrainingNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M6.25 10H5v3h1.25zM8.625 9v4h-1.25V9zM11 7H9.75v6H11z" />
        <path d="M5.406 2a3.009 3.009 0 015.208 0h2.261C13.496 2 14 2.504 14 3.125v11.75c0 .621-.504 1.125-1.125 1.125h-9.75A1.125 1.125 0 012 14.875V3.125C2 2.504 2.504 2 3.125 2zm2.604-.25a1.76 1.76 0 00-1.76 1.76v.24h3.52v-.24a1.76 1.76 0 00-1.76-1.76zM5 3.51c0-.088.004-.174.011-.26H3.25v11.5h9.5V3.25h-1.741c.007.086.011.172.011.26V5H5z" />
      </g>
    </svg>
  )
);
SvgNavigationTrainingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationTrainingNormalXsmall;
